import React from 'react'
import * as myconst from "../constants"
import moment from 'moment';
import { copyIcon, downloadIcon, shareIcon, speakerIcon } from 'assets/icons';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { translateLanguage } from 'services/emailService';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
const ActionForEmail = (props: any) => {
    const params = useParams();
    const { answer, source_name, emailData, setEmailData, setAnswer, handleCreateCon, index, userMessage, handleDownload, handleCopy,
        handleSpeak, handleEmailClick, confirm1, languageTranslated, setLanguageTranslated, setIsLanguageTranslateClicked, notify, stopId, handleCoversationByVersion,
    } = props;
    const languageList = [
        // { name: "Hindi" },
        { name: "English" },
        { name: "Afrikaans" },
        // { name: "Arabic" },
        { name: "German" },
        { name: "French" },
        // { name: "Greek" },
        { name: "Spanish" },
        // { name: "Swedish" },
        // { name: "Russian" },
        // { name: "Persian" },
        // { name: "Japanese" },
        { name: "Portuguese" },
        // { name: "Chinese (simplified)" },
        // { name: "Chinese (traditional)" },
        { name: "Italian" },
        // { name: "Tamil" },
        // { name: "Telugu" },
        // { name: "Marathi" },
        // { name: "Gujrati" },
    ]
    const generateConversationContent = (userQuery: any, answer: any) => {
        let conversationContent = '';
        const userQuestion = userQuery;
        const botAnswer = answer;

        conversationContent += `Query : ${userQuestion}\n\nAnswer : ${botAnswer}\n\n`;

        return conversationContent;
    }
    
    const handleTranslateLanguage = async (e: any) => {
        setLanguageTranslated(e.value);
        setAnswer([]);
        setIsLanguageTranslateClicked(false)
        const body: any = {
            client_env: localStorage.getItem('clientName'),
            source_name,
            language: e?.name?.toLowerCase(),
            content: emailData.content,
            conversation_id: params.id,
            message_id: emailData.message_id,
            prompt: emailData.prompt,
            title: emailData.title,
            settings: emailData.settings,
            user_name: emailData.user_name,
        }
        if (source_name === "email_generation") {
            body.subject = emailData.subject
        }
        const startTime = performance.now();
        try {
            const { result, error } = await translateLanguage(body);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setEmailData(result);
            const endTime = performance.now(); // End the timer
            const elapsedTime = endTime - startTime; // Calculate elapsed time
            await handleCreateCon(result, elapsedTime);
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const conversationContent = generateConversationContent(userMessage?.que, answer[index]?.ans.response.output_text);
    const handleShareEmail = () => {
        const emailLink = `mailto:?subject=Conversation%20Content&body=${encodeURIComponent(conversationContent)}`;
        // const blob = new Blob([conversationContent], { type: 'text/plain' });
        // const url = URL.createObjectURL(blob);
        // const emailLink = `mailto:?subject=Conversation%20Content&body=Please%20find%20the%20conversation%20content%20attached&attachment=${url}`;

        window.location.href = emailLink;
        handleEmailClick(index);
    };
    let featureHistory: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    const copyFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.copy];
    const shareFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.share];
    const TextspeechFlag = featureHistory[myconst?.FEATURE_FLAG_KEY?.textSpeech];
    const downloadFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.download]
    const languageTranslationFlag = featureHistory[myconst?.FEATURE_FLAG_KEY.languageTranslation];

    const handleIncreaseVersion = async () => {
        const currentVersion = answer[index]?.ans.version + 1;
        if (currentVersion <= answer[index]?.ans.total_versions) {
            await handleCoversationByVersion(currentVersion);
        }
    }
    const handleDecreaseVersion = async () => {
        const currentVersion = answer[index]?.ans.version - 1;
        if (currentVersion > 0) {
            await handleCoversationByVersion(currentVersion);
        }
    }
    const onCopy = (answer: any) => {
        if (source_name === "email_generation") {
            const temp = `Subject: ${answer?.ans.subject}\n${answer?.ans.response.output_text}`
            handleCopy(temp)
        } else {
            handleCopy(answer?.ans.response.output_text)
        }
    }
    const onSpeak = (answer: any) => {
        if (source_name === "email_generation") {
            const temp = `Subject: ${answer?.ans.subject}\n${answer?.ans.response.output_text}`
            handleSpeak(temp, answer?.ans.id + index)
        } else {
            handleSpeak(answer?.ans.response.output_text, answer?.ans.id + index)
        }
    }
    return (
        <div className="flex flex-wrap align-items-center w-100 chat-action">
            <div className="flex flex-wrap justify-content-between align-items-center action-date-wrap">
                <div className="conversation-bottom-button-container">
                    {(TextspeechFlag === true || TextspeechFlag === undefined) && (<span className="conversation-section-icon" onClick={() => onSpeak(answer[index])} style={stopId == answer[index]?.ans.id + index ? { backgroundColor: "#F1F1F1", border: "1px solid #404040", borderRadius: "50%" } : {}}><img data-tooltip-id="my-tooltip" data-tooltip-content="Text-to-Speech" src={speakerIcon} alt="speaker-icon" title='Text to Speech' /></span>)}
                    {(copyFlag === true || copyFlag === undefined) && (<span className="conversation-section-icon" onClick={(e) => {onCopy(answer[index]); confirm1(e)}}><img data-tooltip-id="my-tooltip" title='Copy' data-tooltip-content="Copy" src={copyIcon} alt="copy-button"
                    /></span>)}
                    {(downloadFlag === true || downloadFlag === undefined) && (<span className="conversation-section-icon" title='Download' onClick={() => handleDownload(userMessage.que, answer[index]?.ans)}><img data-tooltip-id="my-tooltip" data-tooltip-content="Download" src={downloadIcon} alt="download"
                    /></span>)}
                    {(shareFlag === true || shareFlag === undefined) && (<span className="conversation-section-icon" title='Share' onClick={handleShareEmail}><img data-tooltip-id="my-tooltip" data-tooltip-content="Share" src={shareIcon} alt="share" /></span>)}
                    {(languageTranslationFlag === true || languageTranslationFlag === undefined) && (<span style={{marginLeft: (TextspeechFlag === true || TextspeechFlag === undefined || copyFlag === true || copyFlag === undefined || downloadFlag === true || downloadFlag === undefined || shareFlag === true || shareFlag === undefined) ? "20px" : "0"}} className="glob-language" title='Language Translate'><i className="fa-solid fa-globe"></i><Dropdown value={languageTranslated} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none", border: "none" }} onChange={(e) => handleTranslateLanguage(e.value)} options={languageList} optionLabel="name"
                        placeholder="Select Constraint" className="outline-select w-full" /></span>)}
                    {answer[index]?.ans.total_versions > 1 &&
                        <span className='d-flex align-items-center justify-content-between ml5' style={{ fontSize: "14px" }}>
                            <span onClick={handleDecreaseVersion} style={{ opacity: answer[index]?.ans.version === 1 ? "0.5" : "", pointerEvents: answer[index]?.ans.version === 1 ? "none" : "visible" }} className='conversation-section-icon-email'>{"<"}</span>
                            {answer[index]?.ans.version}/{answer[index]?.ans.total_versions}
                            <span onClick={handleIncreaseVersion} style={{ opacity: answer[index]?.ans.version === answer[index]?.ans.total_versions ? "0.5" : "", pointerEvents: answer[index]?.ans.version === answer[index]?.ans.total_versions ? "none" : "visible" }} className='conversation-section-icon-email'>{">"}</span>
                        </span>
                    }
                </div>
                <div className="response-details">
                    <p className='response-time'>
                        {moment(
                            answer[index]?.ans
                                .created_time?.replace("+00:00", '')
                        ).format(
                            'MMM DD, YYYY HH:mm:ss'
                        )}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ActionForEmail